import React, { useContext, useEffect, useRef, useState } from 'react';
import '../../../css/otp.css';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import { no_waiting_element } from '../../../utils/images';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import OtpInput from 'react-otp-input';
import useToast from '../../Toasts/useToast';
import { ToastThemes } from '../../Toasts/ToastOptions/toastOptions';
import { ProfileContext } from '../../Contexts/contexts';
import useAuth from '../../Contexts/useAuth';
import Services from '../../Services/services';
import { dayJS } from '../../../utils/date';
import { useNavigate } from 'react-router-dom';

export default function OTP() {
	const profileContext = useContext(ProfileContext);

	const { checkAuth } = useAuth();

	const [otp, setOtp] = useState('');
	const [otpTimer, setOtpTimer] = useState(0);

	const enqueueToast = useToast();

	const timer = useRef([]);

	const [otpFetched, setOtpFetched] = useState(status.DEFAULT);

	const navigate = useNavigate();

	const ref = useRef(true);

	const setOtpInterval = (user) => {
		const otpTimestamp = new Date(user.otpRequestDate).getTime();
		const nowTimestamp = new Date().getTime();

		if (nowTimestamp - 600000 + otpTimestamp < 0) return 0;

		const timerInterval = setInterval(() => {
			const requestTimestamp = new Date(user.otpRequestDate).getTime();
			const currentTimestamp = new Date().getTime();

			if (currentTimestamp - 600000 + requestTimestamp > 0) {
				setOtpTimer(requestTimestamp + 600000 - currentTimestamp);
			} else {
				setOtpTimer(0);
				for (const t of timer.current) {
					clearInterval(t);
				}
			}
		}, 1000);

		for (const t of timer.current) {
			clearInterval(t);
		}

		timer.current.push(timerInterval);

		return timerInterval;
	};

	const validateOtp = async () => {
		if (otp.length !== 6) {
			enqueueToast('Le code OTP doit contenir 6 chiffres.', {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: 'Code OTP invalide',
				duration: 3000,
			});
			return;
		}

		try {
			await Services.userService.validateOtp(
				profileContext.user.id,
				parseInt(otp)
			);

			profileContext?.shouldFetchUser();
		} catch (error) {
			console.error(error);
			enqueueToast('Une erreur est survenue.', {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: `Code ERREUR : ${error?.data?.code}`,
				duration: 3000,
			});
		}
	};

	const createOtp = async () => {
		try {
			await Services.userService.createOtp(profileContext.user.id);
			profileContext?.shouldFetchUser();
		} catch (error) {
			console.error(error);
		}
	};

	function CheckRequestDate() {
		if (profileContext === undefined || profileContext?.user === undefined)
			return;

		if (
			profileContext?.user?.otpRequestDate !== undefined &&
			profileContext?.user?.otpRequestDate !== null
		) {
			setOtpFetched(status.FETCHED);

			if (
				dayJS().diff(dayJS(profileContext?.user?.otpRequestDate), 'minute') < 10
			) {
				// user has time to enter his otp number
				if (timer.current.length === 0) {
					setOtpInterval(profileContext?.user);
				}
			}
		} else {
			if (shouldFetchData(otpFetched)) {
				setOtpFetched(status.FETCHED);
				createOtp();
			}
		}
	}

	useEffect(() => {
		if (
			profileContext?.fetchingUser ||
			profileContext?.fetchingClient ||
			profileContext?.fetchingExpert
		)
			return;
		else {
			const firstRender = ref.current;
			if (checkAuth('/otp')) {
				if (firstRender) {
					CheckRequestDate();
					ref.current = false;
				}
			} else {
				navigate('/');
			}
		}
		/* eslint-disable */
	}, [profileContext]);

	useEffect(() => {
		if (profileContext?.user?.emailValidationDate !== null) checkAuth('/otp');
		if (
			profileContext?.user?.emailValidationDate === null &&
			profileContext?.user?.otpRequestDate !== null
		)
			setOtpInterval(profileContext?.user);
	}, [profileContext?.user, checkAuth]);

	function timerToMinutes() {
		const otpTimeToSeconds = otpTimer / 1000;
		const minutes = parseInt(otpTimeToSeconds / 60);
		const seconds = parseInt(otpTimeToSeconds % 60);

		let timeStr = minutes !== 0 ? `${minutes} minutes et ` : '';
		timeStr += seconds !== 0 ? `${seconds} secondes` : '0 seconde';

		return timeStr;
	}

	return (
		<>
			<HeaderMinimal />
			<div className="otp-main-container">
				<div className="otp-left-side">
					<div className="otp-title-container">
						<h1 className="otp-login-title">Entrez le code OTP</h1>
						<div className="otp-details">
							Bienvenue sur notre plateforme ! Pour confirmer votre inscription
							et accéder à votre profil, veuillez saisir le code OTP qui vous a
							été envoyé par SMS sur votre téléphone. Nous sommes ravis de vous
							compter parmi nos membres et sommes là pour vous offrir une
							expérience exceptionnelle.
						</div>
					</div>
					<div className="otp-container">
						<OtpInput
							value={otp}
							onChange={setOtp}
							numInputs={6}
							renderSeparator={<span>.</span>}
							renderInput={(props) => <input {...props} type="number" />}
							inputStyle={'input-otp'}
							containerStyle={{
								justifyContent: 'center',
							}}
						/>
						{otpTimer < 1 && (
							<button className="otp-link" onClick={createOtp}>
								Demander renvoyer le code
							</button>
						)}
						{otpTimer > 1 && (
							<div className="otp-timer-count">
								Possibilité de demander un code dans {timerToMinutes()}
							</div>
						)}
					</div>
					<div className="otp-btn-create-account" onClick={validateOtp}>
						Valider
					</div>
				</div>
				<div className="otp-right-side">
					<img src={no_waiting_element} alt="people smiling" />
				</div>
			</div>
		</>
	);
}
